"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _throttleDebounce = require("throttle-debounce");
var _permission = require("@/utils/permission");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import creatProduct from './creatProduct'
// 权限判断函数
// 权限判断函数
var _default = {
  name: 'securitySetting',
  // components: { creatProduct },
  data: function data() {
    return {
      listLoading: true,
      orList: ['is_open_trust_login_limit', 'is_open_forbid_login_limit', 'is_open_affirm_pwd'],
      inputList: ['allow_login_ip', 'custom_postfix', 'custom_link', 'trust_login_ip', 'forbid_login_ip'],
      countryAll: ['allow_login_region', 'forbid_login_region'],
      countryList: _index.countryList,
      pram: {},
      isCreate: 0,
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    setPlaceholder: function setPlaceholder(key) {
      if (key == 'trust_login_ip') {
        return this.$t('qsrtrust_login_ip');
      }
      if (key == 'forbid_login_ip') {
        return this.$t('qsrforbid_login_ip');
      }
      if (key == 'custom_link') {
        return this.$t('qsrcustom_link');
      }
    },
    checkPermi: _permission.checkPermi,
    setName: function setName(key) {
      return this.$t(key);
    },
    deleteItem: function deleteItem(data, index) {
      var _this = this;
      if (data.id) {
        (0, _infoMessage.deleteSystemConfig)({
          id: data.id
        }).then(function () {
          _this.$message.success(_this.$t('sccg'));
          _this.getList();
        });
      } else {
        this.czljjeList.splice(index, 1);
      }
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _infoMessage.getSafetyConfig)().then(function (res) {
        res.forEach(function (item) {
          if (_this2.countryAll.includes(item.key)) {
            if (item.value && item.value.split(',').length) {
              item.value = item.value.split(',');
            } else {
              item.value = "";
            }
          }
        });
        _this2.tableData.data = res;
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      this.listLoading = true;
      var data = {
        config_list: this.tableData.data.map(function (item) {
          var id = item.id,
            remark = item.remark,
            value = item.value,
            key = item.key,
            condition = item.condition;
          return {
            id: id,
            remark: remark,
            value: _this3.countryAll.includes(key) ? value.toString() : value,
            key: key,
            condition: condition
          };
        })
      };
      var isCreate = sessionStorage.getItem('isCreate');
      (0, _infoMessage.saveSystemConfig)(data).then(function (res) {
        _this3.$message.success(_this3.$t('xgcg'));
        _this3.getList();
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    }
  }
};
exports.default = _default;